import React from 'react'
import UnitCountOne from './child/UnitCountOne';
import TodayOverview from './child/TodayOverview';

const DashBoardLayerOne = () => {

    return (
        <>
            {/* UnitCountOne */}
            <UnitCountOne />

            {/* Today Overview */}
            <TodayOverview />

            <section className="row gy-4 mt-1">

                {/* SalesStatisticOne */}
                {/* <SalesStatisticOne /> */}

                {/* TotalSubscriberOne */}
                {/* <TotalSubscriberOne /> */}

                {/* UsersOverviewOne */}
                {/* <UsersOverviewOne /> */}

                {/* LatestRegisteredOne */}
                {/* <LatestRegisteredOne /> */}

                {/* TopPerformerOne */}
                {/* <TopPerformerOne /> */}

                {/* TopCountries */}
                {/* <TopCountries /> */}

                {/* GeneratedContent */}
                {/* <GeneratedContent /> */}

            </section>
        </>


    )
}

export default DashBoardLayerOne